import ContentLoader from "react-content-loader";
export const tableLoaderBlock = () => {
  return <ContentLoader />;
};
